

export default (state = [], action) => {
  if (action.type == "SET_SCREENS") {
    return action.value;
  }
  return state;
};